(function() {
    'use strict';
    angular
        .module('wamasysApp')
        .factory('ModeleContrat', ModeleContrat);

    ModeleContrat.$inject = ['$resource'];

    function ModeleContrat ($resource) {
        var resourceUrl =  'api/modele-contrats/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
